export default __webpack_public_path__ + "static/media/client-08.7cb1bcb5.webp";